var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ELSCommonUIConstants } from 'components/common';
import { PERFORMANCE_LEVEL_CONFIGS } from 'constants/performanceLevel.constant';
import { getStudentUserFullName } from 'helpers/app.helper';
import { chain, groupBy, keyBy, map, mapValues, maxBy, sumBy, unionBy, uniqBy } from 'lodash';
import moment from 'moment';
import { A2_EXAM_KEY, DEFAULT_DATE_RANGE_UNIX, DEFAULT_PERFORMANCE_LEVEL_SCORE_RANGE, DISPLAY_CUSTOM_FILTER_DATE_FORMAT, DISPLAY_DATE_FORMAT_IN_STUDENT_DETAIL, FILTER_OPTIONS_EXAM_DATE_RANGE, HESI_PRODUCT_EXAM_TYPE, HP_EXAM_KEY, PN_CRITICAL_THINKING_EXAM_KEY, PN_SAFE_MED_PROGRAM_TYPE, RN_CRITICAL_THINKING_EXAM_KEY, RN_SAFE_MED_PROGRAM_TYPE } from 'reports/hesi-ng/constants';
export var getDateRangeFromFilterOption = function (option) {
    var lastMonth = FILTER_OPTIONS_EXAM_DATE_RANGE.lastMonth, lastSixMonths = FILTER_OPTIONS_EXAM_DATE_RANGE.lastSixMonths, lastThreeMonths = FILTER_OPTIONS_EXAM_DATE_RANGE.lastThreeMonths, lastYear = FILTER_OPTIONS_EXAM_DATE_RANGE.lastYear;
    var rangeFrom;
    var rangeTo;
    var currentDay = moment();
    switch (option) {
        case lastMonth:
            rangeFrom = moment().subtract(1, 'M');
            rangeTo = currentDay;
            break;
        case lastThreeMonths:
            rangeFrom = moment().subtract(3, 'M');
            rangeTo = currentDay;
            break;
        case lastSixMonths:
            rangeFrom = moment().subtract(6, 'M');
            rangeTo = currentDay;
            break;
        case lastYear:
            rangeFrom = moment().subtract(12, 'M');
            rangeTo = currentDay;
            break;
        default:
            return DEFAULT_DATE_RANGE_UNIX;
    }
    return { fromDateUnix: rangeFrom.valueOf(), toDateUnix: rangeTo.valueOf() }; // unix in milliseconds
};
var getNGNItemByScoreType = function (ngnItems, isNewScore) {
    if (isNewScore) {
        return (ngnItems || []).filter(function (_a) {
            var isPilot = _a.isPilot;
            return !isPilot;
        });
    }
    return (ngnItems || []).filter(function (_a) {
        var isPilot = _a.isPilot;
        return isPilot;
    });
};
export var getPercentCorrect = function (ngnItems, isNewScore) {
    var filteredNGNItems = getNGNItemByScoreType(ngnItems, isNewScore);
    var uniqueNGNItems = unionBy(filteredNGNItems, function (_a) {
        var questionId = _a.questionId, examId = _a.examId, examGroupId = _a.examGroupId;
        return "".concat(questionId, "-").concat(examId, "-").concat(examGroupId);
    });
    var score = sumBy(uniqueNGNItems, 'awardedTotal');
    var maxScore = sumBy(uniqueNGNItems, 'maxPossibleScore');
    return Math.round((score / maxScore) * 100);
};
export var getFilteredNGNItem = function (ngnItems, examGroupIdsNewScore, isNewScore) {
    if (examGroupIdsNewScore && examGroupIdsNewScore.length > 0) {
        return (ngnItems || []).filter(function (_a) {
            var examGroupId = _a.examGroupId, isPilot = _a.isPilot;
            return examGroupIdsNewScore.includes(examGroupId) && isPilot === !isNewScore;
        });
    }
    return (ngnItems || []).filter(function (_a) {
        var isPilot = _a.isPilot;
        return isPilot === !isNewScore;
    });
};
export var buildNGNCardSummaryExamData = function (ngnItems, examGroupIdsNewScore) {
    var isNewScore = examGroupIdsNewScore && examGroupIdsNewScore.length > 0;
    var filteredNGNItems = getFilteredNGNItem(ngnItems, examGroupIdsNewScore, isNewScore);
    var distinctNGNItems = uniqBy(filteredNGNItems, 'questionId');
    var percentCorrect = getPercentCorrect(ngnItems, isNewScore);
    var numOfNGNStandalones = distinctNGNItems.filter(function (_a) {
        var displayType = _a.displayType;
        return displayType !== 'Case';
    }).length;
    var numOfNGNUnfoldingCases = uniqBy(distinctNGNItems.filter(function (_a) {
        var displayType = _a.displayType;
        return displayType === 'Case';
    }), 'caseId').length;
    return {
        numOfNGNPilotItems: distinctNGNItems.length,
        numOfNGNStandalones: numOfNGNStandalones,
        numOfNGNUnfoldingCases: numOfNGNUnfoldingCases,
        ngnPercentCorrect: percentCorrect,
        newScoreEnable: examGroupIdsNewScore && examGroupIdsNewScore.length
    };
};
export var getExamIdsByExamGroupIds = function (examGroupIds, testTakerData) {
    var examGroupNumberIds = (examGroupIds || []).map(Number);
    var examGroupsIdTestTakerMap = chain(testTakerData)
        .groupBy('examGroupId')
        .mapValues(function (items) { return map(items, 'examId'); })
        .value();
    return examGroupNumberIds.map(function (id) { return examGroupsIdTestTakerMap[id]; }).flat();
};
export var isNewScoreByExamGroupData = function (examGroupData) {
    return (examGroupData || []).some(function (_a) {
        var allowPartialCreditFlag = _a.allowPartialCreditFlag;
        return allowPartialCreditFlag;
    });
};
export var getExamGroupIdsNewScore = function (selectedExamGroups, _a) {
    var examGroupInfo = _a.examGroupInfo;
    var examGroupIds = (selectedExamGroups || []).map(Number);
    var examGroupIdMap = mapValues(keyBy(examGroupInfo, 'examGroupId'), function (v) { return v.allowPartialCreditFlag; });
    return examGroupIds.map(function (id) { return (examGroupIdMap[id] ? id : null); }).filter(Boolean);
};
export var getStudentNGNScoreMap = function (isNewScoreAvailable, isNewGroup, ngnItems) {
    return Object.entries(groupBy(ngnItems, 'examId')).map(function (_a) {
        var key = _a[0], value = _a[1];
        if (isNewScoreAvailable) {
            if (!isNewGroup) {
                return {
                    percentCorrect: -1,
                    examId: key
                };
            }
            return {
                percentCorrect: getPercentCorrect(value, isNewGroup),
                examId: key
            };
        }
        return {
            percentCorrect: getPercentCorrect(value),
            examId: key
        };
    });
};
export var getPerformanceLevelScoreRange = function (acceptableScore, recommendedScore) {
    if (acceptableScore === void 0) { acceptableScore = 0; }
    if (recommendedScore === void 0) { recommendedScore = 0; }
    if (acceptableScore && recommendedScore) {
        var scoreDistance = recommendedScore - acceptableScore;
        return {
            atRisk: {
                max: acceptableScore - 2 * scoreDistance - 1
            },
            belowAcceptable: {
                min: acceptableScore - 2 * scoreDistance,
                max: acceptableScore - 1
            },
            acceptable: {
                min: acceptableScore,
                max: recommendedScore - 1
            },
            recommended: {
                min: recommendedScore
            }
        };
    }
    return DEFAULT_PERFORMANCE_LEVEL_SCORE_RANGE;
};
export var calculatePerformanceLevel = function (studentScore, performanceScoreRange) {
    var foundLevel = Object.keys(performanceScoreRange).find(function (level) {
        var _a = performanceScoreRange[level], _b = _a.min, min = _b === void 0 ? 0 : _b, _c = _a.max, max = _c === void 0 ? 0 : _c;
        return (min === 0 || studentScore >= min) && (max === 0 || studentScore <= max);
    });
    return foundLevel || null;
};
export var getStudentPerformance = function (_a) {
    var examData = _a.examData, selectedExamGroups = _a.selectedExamGroups, ngnItems = _a.ngnItems, acceptableScore = _a.acceptableScore, recommendedScore = _a.recommendedScore;
    var _b = examData.testTakerData, testTakerData = _b === void 0 ? [] : _b, _c = examData.accountInfo, accountInfo = _c === void 0 ? [] : _c, _d = examData.examGroupInfo, examGroupInfo = _d === void 0 ? [] : _d, _e = examData.examInfo, examInfo = _e === void 0 ? [] : _e;
    var isNewScoreAvailable = getExamGroupIdsNewScore(selectedExamGroups, examData).length > 0;
    var filteredNgnItems = isNewScoreAvailable ? ngnItems.filter(function (i) { return !i.isPilot; }) : ngnItems.filter(function (i) { return i.isPilot; });
    var performanceScoreRange = getPerformanceLevelScoreRange(acceptableScore, recommendedScore);
    return testTakerData.reduce(function (studentList, stu) {
        var examGroupId = stu.examGroupId.toString();
        if (!selectedExamGroups.includes(examGroupId)) {
            return studentList;
        }
        var _a = stu.hesiScore, hesiScore = _a === void 0 ? 0 : _a, _b = stu.conversionScore, conversionScore = _b === void 0 ? 0 : _b, _c = stu.examEndDate, examEndDate = _c === void 0 ? null : _c, eolsId = stu.eolsId, examId = stu.examId;
        var _d = accountInfo.find(function (ai) { return ai.eolsId === eolsId; }) || { firstName: '', lastName: '' }, firstName = _d.firstName, lastName = _d.lastName;
        var selectedExamGroup = examGroupInfo.find(function (egi) { return egi.examGroupId === stu.examGroupId; });
        var _e = examInfo.find(function (ei) { return ei.editionId === (selectedExamGroup === null || selectedExamGroup === void 0 ? void 0 : selectedExamGroup.examEditionId); }) || {
            nationalHesiAverage: 0,
            examName: ''
        }, nationalHesiAverage = _e.nationalHesiAverage, examName = _e.examName;
        var mapExamIdWithNGNScore = getStudentNGNScoreMap(isNewScoreAvailable, selectedExamGroup.allowPartialCreditFlag, filteredNgnItems);
        var percentCorrect = (mapExamIdWithNGNScore.find(function (i) { return stu.examId === Number(i.examId); }) || { percentCorrect: -1 }).percentCorrect;
        studentList.push({
            examId: examId,
            eolsId: eolsId,
            examName: examName,
            fullName: getStudentUserFullName({ firstName: firstName, lastName: lastName }),
            meanHesiScore: hesiScore,
            conversionScore: conversionScore,
            nationalHesiAverage: nationalHesiAverage,
            ngnPercentCorrect: percentCorrect,
            dateTaken: examEndDate ? moment(examEndDate).format(DISPLAY_CUSTOM_FILTER_DATE_FORMAT) : '',
            dateTakenUnix: examEndDate,
            performanceLevel: calculatePerformanceLevel(hesiScore, performanceScoreRange),
            guid: stu === null || stu === void 0 ? void 0 : stu.scoringSystemId
        });
        return studentList;
    }, []);
};
var defaultScoreRange = { min: 0, max: 0 };
export var getPerformanceLevelConfig = function (acceptableScore, recommendedScore) {
    if (acceptableScore === void 0) { acceptableScore = 0; }
    if (recommendedScore === void 0) { recommendedScore = 0; }
    var _a = getPerformanceLevelScoreRange(acceptableScore, recommendedScore), _b = _a.atRisk, atRisk = _b === void 0 ? defaultScoreRange : _b, _c = _a.belowAcceptable, belowAcceptable = _c === void 0 ? defaultScoreRange : _c, _d = _a.acceptable, acceptable = _d === void 0 ? defaultScoreRange : _d, _e = _a.recommended, recommended = _e === void 0 ? defaultScoreRange : _e;
    return {
        atRisk: __assign(__assign(__assign({}, PERFORMANCE_LEVEL_CONFIGS.atRisk), atRisk), { range: "<".concat(atRisk.max + 1) }),
        belowAcceptable: __assign(__assign(__assign({}, PERFORMANCE_LEVEL_CONFIGS.belowAcceptable), belowAcceptable), { range: "".concat(belowAcceptable.min, " - ").concat(belowAcceptable.max) }),
        acceptable: __assign(__assign(__assign({}, PERFORMANCE_LEVEL_CONFIGS.acceptable), acceptable), { range: "".concat(acceptable.min, " - ").concat(acceptable.max) }),
        recommended: __assign(__assign(__assign({}, PERFORMANCE_LEVEL_CONFIGS.recommended), recommended), { range: "\u2265".concat(recommended.min) })
    };
};
var defaultPerformanceLevelsCount = {
    atRisk: 0,
    belowAcceptable: 0,
    acceptable: 0,
    recommended: 0
};
export var buildPerformanceLevelsProps = function (_a) {
    var acceptableScore = _a.acceptableScore, recommendedScore = _a.recommendedScore, _b = _a.studentList, studentList = _b === void 0 ? [] : _b, highestScore = _a.highestScore, lowestScore = _a.lowestScore, recommendedRangeLabel = _a.recommendedRangeLabel;
    var performanceLevelsCount = studentList.reduce(function (result, _a) {
        var performanceLevel = _a.performanceLevel;
        var newResult = __assign({}, result);
        newResult[performanceLevel] = (result[performanceLevel] || 0) + 1;
        return newResult;
    }, defaultPerformanceLevelsCount);
    var levelConfig = getPerformanceLevelConfig(acceptableScore, recommendedScore);
    if (recommendedRangeLabel) {
        levelConfig.recommended.range = recommendedRangeLabel;
    }
    var rangeLevelBarChartData = Object.values(levelConfig).map(function (level) {
        return {
            name: level.range,
            subLabel: level.label,
            value: performanceLevelsCount[level.value],
            fillColorClassName: level.fillColorClassName,
            stripeStrokeColorClassName: level.stripeStrokeColorClassName
        };
    });
    var rangeLevelBarChartConfig = {
        barSize: 65,
        xAxisKey: 'name',
        yAxisKey: 'value',
        isStripeColorUsed: false,
        margin: { top: 30, right: 0, bottom: 5, left: 0 }
    };
    return {
        data: rangeLevelBarChartData,
        config: rangeLevelBarChartConfig,
        scoreRange: {
            highestScore: highestScore,
            lowestScore: lowestScore
        }
    };
};
export var getPerformanceValueFromLabel = function (label) { return (Object.values(PERFORMANCE_LEVEL_CONFIGS).find(function (config) { return config.label === label; }) || { value: '' }).value; };
export var getExamGroupIdByAllowPartialCreditFlag = function (examGroupInfo) {
    var examGroupIdMap = groupBy(examGroupInfo, 'examGroupId');
    return mapValues(examGroupIdMap, isNewScoreByExamGroupData);
};
export var mapNGNItemHesiNGToNGNItem = function (ngnHesiNGItem, examMap, examGroupIdMap) {
    var examId = ngnHesiNGItem.examId, isPilot = ngnHesiNGItem.isPilot, itemType = ngnHesiNGItem.itemType, displayType = ngnHesiNGItem.displayType, awardedTotal = ngnHesiNGItem.awardedTotal, maxPossibleScore = ngnHesiNGItem.maxPossibleScore, questionId = ngnHesiNGItem.questionId, caseId = ngnHesiNGItem.caseId, caseTitle = ngnHesiNGItem.caseTitle, timeUsedInSeconds = ngnHesiNGItem.timeUsedInSeconds, categoryName = ngnHesiNGItem.categoryName, examGroupId = ngnHesiNGItem.examGroupId;
    return {
        examId: examId,
        examName: examMap[examId],
        itemType: itemType,
        itemDisplayType: displayType,
        score: awardedTotal,
        maxScore: maxPossibleScore,
        questionId: questionId,
        caseId: caseId,
        caseTitle: caseTitle,
        timeSpent: timeUsedInSeconds,
        skill: categoryName,
        itemTypeCode: itemType,
        isPilot: isPilot,
        allowPartialCreditFlag: examGroupIdMap[examGroupId]
    };
};
export var getStudentExamIdsByTestTaker = function (testTakerData, studentId, selectedExamGroups) {
    var selectedExamGroupIds = (selectedExamGroups || []).map(Number);
    var currentStudentData = (testTakerData || []).filter(function (_a) {
        var eolsId = _a.eolsId, examGroupId = _a.examGroupId;
        return eolsId === Number(studentId) && selectedExamGroupIds.includes(examGroupId);
    });
    if (currentStudentData && currentStudentData.length) {
        return map(currentStudentData, 'examId');
    }
    return [];
};
export var getExamIdByStudentId = function (testTakerData, studentId) {
    var _a;
    var examId = (_a = testTakerData.find(function (testTaker) { return "".concat(testTaker === null || testTaker === void 0 ? void 0 : testTaker.scoringSystemId) === studentId; })) === null || _a === void 0 ? void 0 : _a.examId;
    return examId ? String(examId) : studentId;
};
export var getStudentListDropdownOptions = function (studentList) {
    if (studentList === void 0) { studentList = []; }
    return studentList.map(function (student) {
        var fullName = student.fullName, examId = student.examId;
        return __assign({ name: fullName, key: examId.toString() }, student);
    });
};
export var checkIfExamTypeCAT = function (examGroupAssessmentType) { return examGroupAssessmentType === HESI_PRODUCT_EXAM_TYPE.cat; };
export var getProductName = function (versionId, examType) {
    if (examType === void 0) { examType = ''; }
    var versionStr = versionId ? "v".concat(versionId) : '';
    var examTypeStr = examType ? "".concat(examType, " ") : '';
    return "".concat(examTypeStr).concat(versionStr).trim();
};
export var getPerformanceLevelRelatedData = function (acceptableScore, recommendedScore) {
    var performanceLevel = getPerformanceLevelConfig(acceptableScore, recommendedScore);
    var performanceScoreRange = getPerformanceLevelScoreRange(acceptableScore, recommendedScore);
    var scoreScale = {
        atRisk: {
            max: performanceLevel.atRisk.max,
            label: performanceLevel.atRisk.range
        },
        belowAcceptable: {
            max: performanceLevel.belowAcceptable.max,
            label: performanceLevel.belowAcceptable.range
        },
        acceptable: {
            max: performanceLevel.acceptable.max,
            label: "".concat(acceptableScore, "+")
        }
    };
    return { scoreScale: scoreScale, performanceLevel: performanceLevel, performanceScoreRange: performanceScoreRange };
};
export var getStudentExamResultDetail = function (_a) {
    var score = _a.score, nationalHesiAverage = _a.nationalHesiAverage, classAverage = _a.classAverage, isExamTypeCat = _a.isExamTypeCat, examName = _a.examName, scoreScale = _a.scoreScale, performanceLevel = _a.performanceLevel, productName = _a.productName, examDateTaken = _a.examDateTaken;
    var examInfo = [];
    if (productName) {
        examInfo.push({
            label: 'Product Name',
            value: productName
        });
    }
    if (examDateTaken) {
        examInfo.push({
            label: 'Date Taken',
            value: moment(examDateTaken).format(DISPLAY_DATE_FORMAT_IN_STUDENT_DETAIL)
        });
    }
    var scoreCardProps = {
        score: score,
        showCompareToNational: nationalHesiAverage > 0,
        comparedToNational: Math.round(score - nationalHesiAverage),
        comparedToClassAvg: Math.round(score - classAverage),
        nationalScore: nationalHesiAverage,
        scoreScale: scoreScale,
        isExamTypeCat: isExamTypeCat
    };
    var performanceLevelProps = {
        title: "Performance Level on ".concat(examName),
        performanceLevel: performanceLevel
    };
    return {
        examInfo: examInfo,
        scoreCardProps: scoreCardProps,
        performanceLevelProps: performanceLevelProps,
        isExamTypeCat: isExamTypeCat
    };
};
export var buildExamGroupInfo = function (_a) {
    var students = _a.students;
    return (students || []).map(function (_a) {
        var examGroupId = _a.examGroupId, allowPartialCreditFlag = _a.allowPartialCreditFlag;
        return ({
            examGroupId: examGroupId,
            allowPartialCreditFlag: allowPartialCreditFlag
        });
    });
};
export var formatHesiScore = function (score, isExamTypeCat) {
    if (!score || isNaN(score)) {
        return {
            meanScore: 0,
            displayScore: isExamTypeCat ? 'No viable score is available' : '0'
        };
    }
    var displayScore = isExamTypeCat ? parseFloat(score.toFixed(1)).toString() : Math.round(score).toString();
    return {
        meanScore: Number(displayScore),
        displayScore: displayScore
    };
};
export var getClassAvgScore = function (_a) {
    var studentTestTaker = _a.studentTestTaker, testTakerData = _a.testTakerData;
    var guidList = studentTestTaker.map(function (ot) { return ot.guid; });
    var currentTestTaker = (testTakerData === null || testTakerData === void 0 ? void 0 : testTakerData.filter(function (_a) {
        var scoringSystemId = _a.scoringSystemId;
        return guidList.includes(scoringSystemId);
    })) || [];
    return Math.round(sumBy(currentTestTaker, 'hesiScore') / currentTestTaker.length) || 0;
};
export var getStudentListDateTaken = function (studentList) {
    var _a;
    if (studentList === void 0) { studentList = []; }
    var sortedStudentList = __spreadArray([], studentList, true).sort(function (a, b) {
        var _a, _b;
        return ((_a = a === null || a === void 0 ? void 0 : a.dateTakenUnix) !== null && _a !== void 0 ? _a : 0) - ((_b = b === null || b === void 0 ? void 0 : b.dateTakenUnix) !== null && _b !== void 0 ? _b : 0);
    });
    var firstStudent = null;
    var lastStudent = null;
    if (sortedStudentList.length > 0) {
        _a = sortedStudentList.length === 1 ? [sortedStudentList[0], sortedStudentList[0]] : [sortedStudentList[0], sortedStudentList[sortedStudentList.length - 1]], firstStudent = _a[0], lastStudent = _a[1];
    }
    return "\n  ".concat(moment(firstStudent === null || firstStudent === void 0 ? void 0 : firstStudent.dateTakenUnix).format(ELSCommonUIConstants.momentDateFormat.datePrimary), " - ").concat(moment(lastStudent === null || lastStudent === void 0 ? void 0 : lastStudent.dateTakenUnix).format(ELSCommonUIConstants.momentDateFormat.datePrimary));
};
export var checkHPExam = function (productName) { return !!productName && productName.startsWith("".concat(HP_EXAM_KEY, " ")); };
export var checkA2Exam = function (productName) { return !!productName && productName.includes("".concat(A2_EXAM_KEY)); };
export var isHideConversionScoreColumn = function (productName) {
    return !!productName && (productName.startsWith("".concat(RN_CRITICAL_THINKING_EXAM_KEY, " ")) || productName.startsWith("".concat(PN_CRITICAL_THINKING_EXAM_KEY, " ")));
};
export var generateReferenceYAxisLines = function (maxValue) {
    if (!maxValue || maxValue <= 100) {
        return [20, 40, 60, 80, 100];
    }
    var step = Math.ceil(maxValue / 4 / 100) * 100;
    return [0, step, step * 2, step * 3, step * 4];
};
export var getMaxValue = function (data) {
    var _a, _b;
    var maxAggregate = ((_a = maxBy(data, 'aggregate')) === null || _a === void 0 ? void 0 : _a.aggregate) || 0;
    var maxNational = ((_b = maxBy(data, 'national')) === null || _b === void 0 ? void 0 : _b.national) || 0;
    return Math.max(maxAggregate, maxNational);
};
export var checkIfSafeMedExam = function (programType) { return !!programType && (programType === RN_SAFE_MED_PROGRAM_TYPE || programType === PN_SAFE_MED_PROGRAM_TYPE); };
